import { Component, OnInit, OnDestroy, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';
import { ProjectDataPerimetro } from 'src/app/entities/project-data-perimetro.entity';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { ConfigService } from 'src/app/app.config';
import { SettingsboxComponent } from '../settingsbox/settingsbox/settingsbox.component';
import { Router } from '@angular/router';
import { BuilderService } from '../builder.service';
import { BuilderHistorialService } from '../builder-historial.service';
import { ModelService } from 'src/app/services/model.service';
import { Subscription } from 'rxjs';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { AlertDataTypes } from 'src/app/alert/alert-data.types';
import { Scheme2Component } from '../scheme2/scheme2.component';
import { Utils } from '../../utils.module';
import { PropagarService } from 'src/app/services/propagar.service';
import { Budget } from '../budget';
import { ProjectDataScheme } from 'src/app/entities/project-data-scheme';
import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import * as actionsPath from '../../store/path/path.actions';
import { MODE } from '../bulder-datas';
import { setMode } from 'src/app/store/builder/builder.actions';
import { ProjectDataStatusList } from '../../entities/project-data-status.list';
import { AlertComponent } from 'src/app/alert/alert.component';
import { AppState } from 'src/app/app.reducers';
import { ParseProjectVersion } from 'src/app/utils/parse-project-version';


@Component({
	selector: 'app-canvas-renderer',
	templateUrl: './canvas-renderer.component.html',
	styleUrls: ['./canvas-renderer.component.scss']
})
export class CanvasRendererComponent implements OnInit, OnDestroy, AfterViewInit {

	//#region #################### Constantes.
	// MODE2D: Estado por defecto, se ve el editor de perímetros (SVG).
	// MODE3D: Visualizador de perímetros 3D (THREEjs).
	public VIEW_MODE = { MODE2D: '2d', MODE3D: '3d' };

	// Utilizados por el TOOLBAR, opciones.
	public OPTIONS: any = {
		DRAG: 'drag',
	};
	// Utilizados por el TOOLBAR, modos.
	/*private MODE: any = {
		DRAG: 'dragMode',	// Mano pointer (default).
		DRAW: 'drawMode',	// Cruz con punto en medio.
		DOOR: 'doorMode',	// Mano
		STAIR: 'elevationTool',	// Mano
		ERASE: 'eraseMode',	// Goma.
	};*/
	//#endregion

	//#region #################### @ViewChildren's
	// Componente encargado de la configuración de los perímetros.
	@ViewChild('settingsBox') settingsBox: SettingsboxComponent;

	// Editor de perímetros (SVG).
	@ViewChild('Scheme2D') scheme2Component: Scheme2Component;
	//#endregion

	@ViewChild('alertWindow') alertWindow: AlertComponent;

	//#region #################### @Input's
	// Proyecto cargado.
	@Input() projectData: ProjectData;
	public posicionGrid: any[] =[];
	//#endregion


	//#region #################### Parámetros globales.
	// Almacena el actual estado visual (MODE2D o MODE3D)
	public currentViewMode: string = this.VIEW_MODE.MODE2D;		// MVC acción.
	public disabled2D: boolean = false;

	// Si se pone a true indica que la longitud del total de los perímetros exceda del máximo (ConfigService.MAX_PERIMETER_LENGTH_METERS).
	public totalLengthErr = false;								// MVC acción.

	// Si se pona a true activa pantalla completa.
	public fullscreen = false;									// MVC acción.

	// Actual indice del perímtero seleccionado, -1 si no hay perímtero seleccionado.
	public indexPerimeterSelected = -1;	// projectData.perimetro[]
	//#endregion

	//#region #################### Parámetros locales.
	// Arreglo de subscribes, utilizado para liberarlos todos al mismo tiempo.
	private subscriptions: Subscription[] = [];

	// Puntero al componente SVG (HTML).
	private SVG: any;

	// Puntero al footer de la página (HTML), usado para fullscreen.
	//private FOO TER: any;

	// Utilizado para mínimizar y máximizar el toolbar.
	public minimizedToolBar = false;					// MVC acción.

	// Oculta todos los bonotes menos la mano, esto ocurre cuando el proyecto no es un borrador.
	public disabledToolBox = false;						// MVC acción.

	// Actual modo de edición del toolbar.
	private currentDrawing: string = MODE.DRAG;
	//#endregion

	public isMinimized: boolean = true;

	//#region ################### MVC
	// Longitud total de los perímetros del proyecto.
	public totalLengthStr = '0,00';

	// Usados para almacenar el tamaño del area de dibujo.
	public schemeSizeWidth = '0';
	public schemeSizeHeight = '0';
	//#endregion

	// Store.
	private _iComingFrom3D = false;

	//Valores del posicion del perímetro
	public azopardo :[]=[];

	// #################### CODE
	constructor(
		private store: Store<AppState>,
		private router: Router,
		public modelService: ModelService,
		private builderService: BuilderService,
		public historialService: BuilderHistorialService,
		public el: ElementRef,
	) {
		const bBtnSee: boolean = (localStorage.getItem('bBtnSee') === 'true');
		if (bBtnSee) { this.isMinimized = bBtnSee; }
	}

	//#region #################### Eventos propios de angular.
	// Solo se ejecuta una vez.
	public ngOnInit() {
		// Capturar el evento Resize del browser.
		window.addEventListener('resize', () => { this.onResize(); });

		// Iniciar el proyecto, primero comprobar si hay un proyecto en el localStorage.
		const tempData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		if (tempData) this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));

		// Si llegados a este punto sigue siendo nulo, nuevo proyecto
		if (!this.projectData) {
			this.projectData = new ProjectData();
			this.projectData._id = '';
			this.projectData.nombre = '';
			this.projectData.estado = 0; // Borrador.
			this.projectData.renderer = Utils.SCHEME2;
			this.projectData.fechaCreacion = new Date();
			this.projectData.userId = this.modelService.getUser().getData().id;
			this.projectData.idioma = this.modelService.getLanguage().currentLanguage;
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
			
			this.projectData.scheme = new ProjectDataScheme(); // x:-10000, y:-10000, scale:1
			let parse = new ParseProjectVersion();
			this.projectData.valoresCentrado = parse.computeCenter(this.projectData);
		}

		// Asegurarse que tiene el userId.
		if (!this.projectData.userId || this.projectData.userId === '') this.projectData.userId = this.modelService.getUser().getData().id;

		// Asegurarse que tiene el idioma.
		if (!this.projectData.idioma) this.projectData.idioma = this.modelService.getLanguage().currentLanguage;


		// Limpiar perímetros vacios o con una coordenada (un perímetro debe tener como mínimo dos coordenadas).
		let newPerimetros = [];
		for (let p of this.projectData.perimetro) if (p.coordenadas.length > 1) newPerimetros.push(p);
		this.projectData.perimetro = newPerimetros;
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

		// Captura cuando se navega por el historial.
		this.historialService.clearHistorial();
		this.subscriptions.push(this.historialService.onUpdateRenderer.subscribe((projectData: ProjectData) => {
			// Asigna el proyecto que hay en el historial.
			this.projectData = projectData;
		}));

		// TODO Emitido desde app.component (onKillFocus) ¿?.
		this.subscriptions.push(this.modelService.saveProjectSignal.subscribe((newProjectData: ProjectData) => {
			// Recibe un nuevo proyecto, pero por el momento no se ha podido capturar cuando se ejecuta.
			this.onProjectUpdate(newProjectData);
			//console.error("this.modelService.save ProjectSignal");
		}));

		this.subscriptions.push(this.modelService.sendForAprovalSqueme.subscribe((value: string) => {
			this.sendForAproval();
		}));

		// En caso de no existir un proyecto ir al Hold.
		if (!this.projectData) {
			this.router.navigate(['/hold']);
			return;
		}

		// Emitido por app.component (new Project) crear nuevo proyecto.
		/*this.subscriptions.push(this.modelService.reset SignalCanvas.subscribe((projectData) => {
			// Poner en modo esquema.			this.current ViewMode = this.VIEW_MODE.MODE2D;
			// Limpiar historial.			this.historialService.clearHistorial();			this.project Data = projectData;
			Utils.DOMWebHeader _setTitleProject(this.projectData.nombre);
			let str = ProjectDataStatusList.find(item => item.value === this.projectData.estado);
			let text = this.modelService.getString('builder _status') + ' : ';
			text += ((str) ? this.modelService.getString(str.label) : this.modelService.getString('project_list_state_draft'));
			Utils.DOMWebHeader _setStatusProject(text);
			this.projectData.s cheme = new ProjectDataScheme();	// x:-10000, y:-10000, scale:1
			// Poner el editor en modo DRAW.			this, this.set CurrentMode(MODE.DRAW); //this.current Drawing  MODE.DRAW;
			// Guardar el nuevo proyecto en el localStorage.			this.saveToLocal();		}));*/

		// Limpiar el historial.
		//this.historialService.clearHistorial();

		this.subscriptions.push(this.modelService.squemaGoToHomeSignal.subscribe((data: boolean) => {
			// Cuando se carga siempre aparece en emodo 2D.
			this.currentViewMode = this.VIEW_MODE.MODE2D;
		}));

		// Subscribirse al evento global 'GProjectLoad' provocado en la carga de un proyecto.
		//Propagar Service.get('G ProjectLoadScheme').subscribe((data: any) => {
		this.modelService.GProjectLoadScheme.subscribe((data: string) => {
			//console.log('this.modelService.GProjectLoadScheme.subscribe :: ' + data);

			// Obtener del localstorage el proyecto que fue previamente actualizado.
			const project = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
			// Debe ser un Esquema.
			if (project.renderer !== Utils.SCHEME2) return;

			//Cuando se carga siempre aparece en modo 2D menos si biene del 3D.
			if (!this._iComingFrom3D) this.currentViewMode = this.VIEW_MODE.MODE2D;

			// Se acepta el proyecto, los asignamos para poder utilizarlo.
			this.projectData = project;

			// Si no tiene perímetros definidos entra en modo DRAW, en caso contrario entra en modo DRAG.
			//this.setCurrentMode(this.projectData.perimetro.length > 0 ? MODE.DRAG : MODE.DRAW);

			// Limpiar el historial, añadir el proyecto.
			this.historialService.clearHistorial();
			this.historialService.addHistorial(this.projectData);
			// Actualizar el SVG.
			if (this.scheme2Component) this.scheme2Component.updateFromParent(data);
			// Actualizar el nombre del proyecto.
			Utils.DOMWebHeader_setTitleProject(this.projectData.nombre);

			// Obtener el estado del proyecto para mostrarlo en pantalla.
			let str = ProjectDataStatusList.find(item => item.value === this.projectData.estado);
			let text = this.modelService.getString('builder_status') + ' : ';
			text += ((str) ? this.modelService.getString(str.label) : this.modelService.getString('project_list_state_draft'));
			Utils.DOMWebHeader_setStatusProject(text);

			// OLD Si no tiene perímetros definidos entra en modo DRAW, en caso contrario entra en modo DRAG.
			// OLD this.scheme2Component.activateCursor(this.projectData.perimetro.length > 0 ? this.scheme2Component.CURSOR.POINTER : this.scheme2Component.CURSOR.DRAW);
			// Entrar en modo DRAW ha provocado quejas en los usuarios, ahora entra en modo DRAG.
			if (this.scheme2Component) this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.POINTER);
			this.setCurrentMode(MODE.DRAG);

			// Limpiar perímetros vacios o con una coordenada (un perímetro debe tener como mínimo dos coordenadas).
			//let clean = new CleanPerimeters();
			//this.projectData.perimetro = clean.clean(this.projectData.perimetro);

			// OLD let newPerimetros = [];	for (let p of this.projectData.perimetro) { if (p.coordenadas.length > 1) {	newPerimetros.push(p); // TO DO Limpiar posibles errores de duplicidad en postes. }}
			// OLD this.projectData.perimetro = newPerimetros;
			//localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

			this.onResize();
		});

		// A falta de REDUX buenas son TORTAS.
		PropagarService.get('GProjectChangeMCScheme').subscribe((mc: number) => {
			//console.log(`>>> MC:: projectData.mc = ${this.projectData.mc}, mc = ${mc} `);
			this.projectData.mc = mc;
		});

		this.store.subscribe(state => {
			this._iComingFrom3D = state.uiPath.iComingFrom3D;
		});

		this.setCurrentMode(MODE.DRAG); // MODE.DRAG;
	}

	// Destructor.
	public ngOnDestroy(): void {
		// Liberar todos los subscribes.
		this.subscriptions.map((item: Subscription) => { item.unsubscribe(); });
	}

	// Después de construir el HTML.
	public ngAfterViewInit() {
		// Obtener elementos nativos de HTML.
		this.SVG = document.getElementById('idSVG').parentElement;
		this.onResize();
		//this.FOO TER = document.getElementById('idFooter');
	}
	//#endregion

	private setCurrentMode(mode: string) {
		this.store.dispatch(setMode({ mode: mode }));
		this.currentDrawing = mode;
	}

	public accionHandleVisibility(action: boolean) {

	}

	//#region #################### Historial
	// Usadas para activar y desactivar los botones (Deshacer/Rehacer) del toolBar.
	public canHistorialNext() { return this.historialService.hasHistorialForward };		// MVC acción.
	public canHistorialBack() { return this.historialService.hasHistorialBackward; };	// MVC acción.
	//#endregion

	//#region #################### TOOLBAR
	// Utilizados para habilitar y desabilitar los botones del toolbar.
	public ModeDrag(): boolean { return this.currentDrawing === MODE.DRAG; }			// MVC acción.
	public ModeDraw(): boolean { return this.currentDrawing === MODE.DRAW; }			// MVC acción.
	public ModeDoor(): boolean { return this.currentDrawing === MODE.DOOR; }			// MVC acción.
	public ModeElevation(): boolean { return this.currentDrawing === MODE.STAIR; }		// MVC acción.
	public ModeErase(): boolean { return this.currentDrawing === MODE.ERASE; }			// MVC acción.

	// Eventos de los botones TOOLBAR (Deshacer/Rehacer) del toolBar.
	public clickUndo() {
		this.historialService.historialBack();
		this.cleanProject();
		this.scheme2Component.refresh(this.projectData);
	}						// MCV event.

	public clickRedo() {
		this.historialService.historialNext();
		this.cleanProject();
		this.scheme2Component.refresh(this.projectData);
	}						// MCV event.

	private cleanProject() {
		let newPerimeters: ProjectDataPerimetro[] = [];
		for (let p of this.projectData.perimetro) {
			if (p.coordenadas && p.coordenadas.length > 1) {
				newPerimeters.push(p);
			}
		}
		this.projectData.perimetro = newPerimeters;
	}

	// Evento de los botones de borrado.												// MCV event.
	public btnEraseAll() {
		return !(this.projectData && this.projectData.perimetro
			&& this.projectData.perimetro.length && (this.projectData.perimetro.length > 0)
			//	&& !this.historialService.hasHistorialForward
			&& (this.currentDrawing !== MODE.DRAW));
	}

	// Máximiza o mínimiza la toolbar.												// MVC acción.
	public handleState() {
		if (this.projectData.estado == 0) this.minimizedToolBar = !this.minimizedToolBar;
	}

	public handleStateSee(): void {
		this.isMinimized = !this.isMinimized;
		localStorage.setItem('bBtnSee', this.isMinimized.toString());
	}


	// Esconde o muestra el resto de botones menos la mano que siempre se ve.
	// Cuando un proyecto no es borrador solo se ve la mano ¿qué utilidad tiene?
	public UIMinimize(): boolean { return this.minimizedToolBar || this.disabledToolBox; }			// MVC acción.

	public drawEraseAllMode() {
		this.scheme2Component.eraseAllPerimeters();
		this.indexPerimeterSelected = -1;
	}


	// Petición para activar el modo mover grid y selección.
	// Se pide a scheme2 que se ponga en modo drag, si es pobible retorna true.
	public setDragMode() {															// MVC event.
		// Si ya se está en ese modo no se ejecuta.
		if (this.currentDrawing === MODE.DRAG) return;

		// Si se cumple ponemos la toolbar en modo Drag.
		if (this.scheme2Component.setDragMode()) {
			this.setCurrentMode(MODE.DRAG);
			this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.POINTER); // resetear cursor
		}
	}
	//#endregion

	//#region #################### TOOLBAR PETICIONES de padre (this) a hijo (scheme2).
	// Petición para activar la creación de un nuevo perímetro.
	// Se pide a scheme2 que se ponga en modo draw, si es pobible retorna true.
	public setDrawMode() {															// MVC event.
		this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.DRAW); // draw cursor
		// Si ya se está en ese modo no se ejecuta.
		if (this.currentDrawing === MODE.DRAW) return;

		// Si se cumple ponemos la toolbar en modo Draw.
		if (this.scheme2Component.setDrawingMode()) {
			this.setCurrentMode(MODE.DRAW); // this.current Drawing = MODE.DRAW;
			// Reiniciamos el perímtero seleccionado.
			this.indexPerimeterSelected = -1;
		}
	}

	// Petición para activar el modo puertas.
	// Se pide a scheme2 que se ponga en modo door, si es pobible retorna true.
	public setDoorMode() {															 // MVC event.
		// Si ya se está en ese modo no se ejecuta.
		if (this.currentDrawing === MODE.DOOR) return;
		this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.POINTER); // resetear cursor

		// Si se cumple ponemos la toolbar en modo Door.
		if (this.scheme2Component.setDoorMode()) this.setCurrentMode(MODE.DOOR); // this.MODE.DOOR;
	}


	// Petición para activar el modo elevaciones (escalones).
	// Se pide a scheme2 que se ponga en modo elevationTool, si es pobible retorna true.
	public setStairMode() {																 // MVC event.
		// Si ya se está en ese modo no se ejecuta.
		if (this.currentDrawing === MODE.STAIR) return;
		this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.POINTER); // resetear cursor

		// Si se cumple ponemos la toolbar en modo ElevationTool.
		if (this.scheme2Component.setElevationMode()) this.setCurrentMode(MODE.STAIR); // MODE.STAIR;
	}

	// Petición para activar el modo de borrado (perímetros, puertas, elevaciones).
	// Se pide a scheme2 que se ponga en modo Erase, si es pobible retorna true.
	public setEraseMode() {																// MVC event.
		// document.body.style.cursor = "url(assets/icon/eraser.svg), auto";
		// Si ya se está en ese modo no se ejecuta.
		if (this.currentDrawing === MODE.ERASE) return;
		this.scheme2Component.activateCursor(this.scheme2Component.CURSOR.ERASE); // eraser cursor

		// Si se cumple ponemos la toolbar en modo Erase.
		if (this.scheme2Component.setEraseMode()) this.setCurrentMode(MODE.ERASE); // this.MODE.ERASE;
	}
	//#endregion

	//#region #################### Peticiones desde schenme2 al padre (this).
	// Actualizar el toolbox desde scheme2.
	onActualizarToolBar(value: string) {											// MVC acción.
		if (value === 'NEW') this.setCurrentMode(MODE.DRAW);
		else if (value === 'DRAG') this.setCurrentMode(MODE.DRAG);
	}

	// scheme2 avisa devolviendo el index del perímtero seleccionado.
	onSelectPerimeter(index: number) {
		// Actualizar el actual índice de perímetro.
		this.indexPerimeterSelected = index;
	}

	// scheme2 avisa que vuelve del visor 3D al esquema y se debe actualizar Ancho/Alto de la UI.
	onChange3Dto2D() {
	//	console.log('onChange3Dto2D()');
		// Avisar que sale del 3D.
		this.store.dispatch(actionsPath.iDontComingFrom3D());

		// Si es posible recuperar el puntero al svg, actualizar
		this.onResize();
		this.setCurrentMode(MODE.DRAG);
	}
	onChangeGrid($event:any){
		this.posicionGrid = $event;
	}

	// scheme2 avisa que se modifica el zoom, util para ctualizar la UI (Ancho esquema, Alto esquema).
	onZoomChange2() {
		//console.log('ZOOM');
		this.onResize();
	}

	// scheme2 avisa que se actualice la longitud total del perímtero.
	onChangeLengthPerimeters(lengths: any) {
		this.totalLengthStr = lengths.longitudStr;
		this.totalLengthErr = lengths.longitud > ConfigService.MAX_PERIMETER_LENGTH_METERS;
	}
	//#endregion

	//#region #################### UI
	public refScreenShot() {
		this.scheme2Component.actualizarScreenshot();
	}

	// Muestra u oculta los botones de zoom, fullscreen y toolbar.
	public UIHidden(): boolean {																// MVC acción.
		return (this.projectData.estado != 0) || (this.currentViewMode !== this.VIEW_MODE.MODE2D);
	}

	// Cambia de pantalla completa a normal y viceversa.
	public onToggleChange() {											// MVC event.
		// Cambia el actual estado.
		this.fullscreen = !this.fullscreen;
		Utils.DOM_WebHeader_show(!this.fullscreen);

		// Avisar al hijo del cambio.
		this.scheme2Component.toggleFullscreen(this.fullscreen);
	}
	//#endregion

	//#region #################### Varios
	// Cálcula el ancho y alto de la zona de cliente y la pasa a metros.
	private onResize(): void {																	// MVC acción.
		// Asegurarse que los punteros están actualizados.
		if (this.SVG && this.SVG.clientWidth > 0 && this.scheme2Component) {
			this.schemeSizeWidth = ((this.SVG.clientWidth * this.scheme2Component.getUnit()) / 10).toFixed(0);
			this.schemeSizeHeight = ((this.SVG.clientHeight * this.scheme2Component.getUnit()) / 10).toFixed(0);
		}
		else {
			let _svg = document.getElementById('idSVG');
			if (_svg) {
				this.SVG = _svg.parentElement;
				this.schemeSizeWidth = ((this.SVG.clientWidth * this.scheme2Component.getUnit()) / 10).toFixed(0);
				this.schemeSizeHeight = ((this.SVG.clientHeight * this.scheme2Component.getUnit()) / 10).toFixed(0);
			}
		}
	}

	// Cambia entre el modo 2D (esquema) y 3D.
	public onModeChange(newMode: string) {
		// Menú, fue eliminado.
		// this.modelService.closeMenuContextEditors.emit('');	// MVC event.

		// Solo cambia si es un modo distinto.
		if (this.currentViewMode === newMode){
			
			return;
		} 

		// Si vuelve al modo 2D ser carga el proyecto del localStorage.
		if (newMode === this.VIEW_MODE.MODE2D) {
			this.store.dispatch(actionsPath.iDontComingFrom3D());
			this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		}
		else {
			this.store.dispatch(actionsPath.iComingFrom3D());
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

		}
		// Actualiza el modo actual.
		this.currentViewMode = newMode;
	}

	// No es lo más optimo y sería más apropiado actualizar el settings solo cuando es abierto.
	public getCurrentPerimeter(): ProjectDataPerimetro {
		return (this.scheme2Component) ? this.projectData.perimetro[this.scheme2Component.INDEXPerimeterSelected] : undefined;
	}

	// Cambio de zoom desde el padre (this), se debe comunicar al hijo (scheme2).
	public onZoomChange(zoomValue: number) {//	console.log('ZOOM::' + zoomValue);
		// Comunica a scheme2 (hijo) el nuevo zoom.
		this.scheme2Component.zoom(0, 0, (zoomValue === -1));		// MVC acción.
	}

	// Permitir ir al modo 3D o pedir presupueto.													// MVC acción.
	public get readyForRender(): boolean {
		if (!this.projectData.perimetro) return false;				// Debe existir el objeto perímetro.
		if (this.projectData.perimetro.length == 0) return false;	// Debe existir como mínimo un perímetro.
		for (let p of this.projectData.perimetro) {
			
			if (p.coordenadas.length < 2) return false;
			if (!p.producto) return false;							// Debe existir un producto.
			if (!p.producto.panel) return false;					// Debe existir un panel.
			if (!p.producto.tipoPanel) return false;				// Debe existir un tipo de panel.
			for (let d of p.puertas) {
				if (!d.puerta) return false;						// Hay puertas pero no se ha seleccionado el tipo.
			}
		}
		return !(this.currentDrawing === MODE.DRAW);
	}
	public onStateRender($event){
		try{

			this.disabled2D = $event;
		}catch(error){
			console.error(error);
		}
		
	}
	//#endregion

	//#region #################### CREAR PRESUPUESTO
	// Crear el pedido y enviarlo a Navision para recibir el presupuesto.
	public sendForAproval() {
	//	console.log('>>> Presupuesto');
		// Crear un nuevo presupuesto.
		let budget = new Budget(this.projectData);

		if (this.projectData._id == undefined || this.projectData._id == '') {
			console.log('No tiene id proyecto');
		}

		if (this.projectData.userId == undefined || this.projectData.userId == '') {
			this.projectData.userId = this.modelService.getUser().getData().id;
			console.error("projectData.userId is undefined or empty.");
			return;
		}

		if (this.projectData.userIdRivisa == undefined || this.projectData.userIdRivisa == '') {
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
			console.error("projectData.userIdRivisa is undefined or empty.");
			return;
		}

		if (!this.projectData.idioma) this.projectData.idioma = this.modelService.getLanguage().currentLanguage;

		this.projectData.scheme = this.getTranslateScaleSVG();

		// Si el presupuesto es operativo retorna true, modifica el proyecto.
		if (budget.createBudget()) {
			// Avisar si se excede de la longitud máxima.
			if (budget.result.lengthExceeded) {
				// En caso de exceder la longitud máxima se avisa al usuario.
				const alertData = new AlertData(); // Crear popup.
				alertData.message = this.modelService.getString('builder_error_max_length') + ' ';
				alertData.message += ((this.scheme2Component) ? this.scheme2Component.getTotalLengthPerimeters() : 0).toFixed(2) + ' ';
				alertData.message += this.modelService.getString('builder_error_max_length_sub') + ConfigService.MAX_PERIMETER_LENGTH_METERS + 'm)';
				alertData.title = this.modelService.getString('builder_error_max_length_title');
				alertData.type = AlertDataTypes.ACCEPT;

				// Mostrar el popup.
				this.alertWindow.show(alertData);
			}

			// Almacena dirección de retorno.
			this.store.dispatch(pathActions.goFront({ path: '/scheme' }));

			//############################################################################
			//############################################################################
			//## USO EXCLUSIVO PARA DESARROLLO, SOLO SE CUMPLE EN LOCAL.
			//if (document.location.origin.includes('localhost:7890')) {
				//if (!verPresupuesto) this.currentViewMode = this.VIEW_MODE.M3D;
			//	return;
			//}
			//############################################################################
			//############################################################################


			// Hacer la petición a Node para que devuelva el presupuesto calculado.
			let subs: Subscription = this.builderService.budget(this.projectData).subscribe(
				(response) => {
					console.log("RESPONSE ",response)
					// Si todo fue bien redireccionamos al detalle del proyecto.
					subs.unsubscribe();
					this.projectData = response;
					this.onProjectUpdate();
					localStorage.setItem(Utils.PREVIOUS_CURRENT_PROJECT, this.projectData._id);
					this.router.navigate(['/project-detail']);
					console.log("Presupuesto calculado")
				},
				(error) => {
					// Puede que Navision no esté operativo.
					console.error('Budget', error);
					console.log("Error en Navision con el proyecto")
				});
		}
		else {
			// ERROR, no se ha podido crear los datos para el servidor, no se ha hecho la petición a Node.
			console.log("No se ha hecho la petición a NODE")
			console.error(budget.result.error.message);
		}
	}

	// Evento capturado desde el settings.
	public onProjectUpdate(newProjectData?: ProjectData) {
		// Asegurarse que se almacena el nombre, old bug.
		if (newProjectData) this.projectData.nombre = newProjectData.nombre;
		this.saveToLocal();
	}

	// Llamado desde el settings HMTL
	public saveToLocal() {
		if (!this.projectData) return;

		// Eliminar nulos
		if (this.projectData.perimetro) {
			this.projectData.perimetro = this.projectData.perimetro.filter(Boolean);
			let index = 0;
			this.projectData.perimetro.forEach((e) => { e.zIndex = index; index++; });
		}

		this.projectData.scheme = this.getTranslateScaleSVG();

		this.projectData.idioma = this.modelService.getLanguage().currentLanguage;
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

	}
	//#endregion

	private getTranslateScaleSVG(): ProjectDataScheme {
		const plane = document.getElementById('idPlaneSVG');
		let result = new ProjectDataScheme();
		if (plane) {
			const transform = plane.getAttributeNS(null, 'transform');
			if (transform) {
				const datas = transform.replace(') ', ')#').split('#');
				for (let str of datas) {
					if (str.startsWith('scale')) {
						result.scale = parseFloat(str.replace('scale(', '').split(',')[0]);
					}
					else if (str.startsWith('translate')) {
						let nums = str.replace('translate(', '').replace(')', '').split(',');
						result.x = parseFloat(nums[0]);
						result.y = parseFloat(nums[1]);
					}
				}
			}
		}
		return result;
	}
}



	// Crear un proyecto satélite desde el editor esquema.
	// Muestra el popup de creación de proyectos (solo satélite), se debe rellenar el nombre o cancelar la acción.
	// En caso de aceptar se crea el proyecto de tipo satélite y se cambia a la vista satélite.
/*public on2 dModeChange() {
	// Crear el popup (formulario) de satélite para la inserción del nombre o cancelación.
	const newProjectData: NewPr ojectData = new NewPro jectData();

	// Mostrar el popup.
	newProjectData.message = this.modelService.getString('app_ remove_current');
	newProjectData.title = this.modelService.getString('menu_project_new');
	newProjectData.type = 'modal';
	this.newProjec tWindow.show(1);

	// Capturar la respuesta y actuar en consecuencia.
	const remSubscription = this.modelService.newProjectResultSignal
		.subscribe(
			(dt: NewProj ectData) => {
				if (dt.estado === 1) { // Solo satélite.
					remSubscription.unsubscribe();			// Desubcribirse.
					this.newProje ctWindow.close();			// Cerrar el popup.

					// Crear el proyecto limpio.
					this.project Data = new ProjectData();
					this.projectData.fechaCreacion = new Date();	// Almacenar la fecha actual.
					this.projectData.perimetro = [];				// Asegurarse que tiene un array vacío.
					this.projectData.nombre = dt.nombre;			// Almacenar el nombre del proyecto.
					this.projectData.renderer = Utils.SATELITE;		// Indicar el tipo.
					this.projectData.idioma = this.modelService.getLanguage().currentLanguage;	// Actualiza idioma del proyecto.

					// Limpiar historial.
					this.historialService.clearHistorial();

					// Almacenar el nuevo proyecto en el localStorage.
					localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

					// Forzar el refresco del título del proyecto en la UI.
					document.getElementById('NOMBRE PROYECTO').innerText = dt.nombre;

					// Navegar a la vista satélite.
					this.router.navigate([' /satelite']);
				}
			});
}*/